"use client";
import clsx from "clsx";
import React, { ReactNode, useState } from "react";

import Button from "components/Button";

export type LineTabType = {
  label: string;
  children: ReactNode;
  width?: string;
  className?: string;
};

// 0: 区画一覧, 1: 区画グループ一覧
type ActiveTabIndex = 0 | 1;

const LineTabs = ({
  tabs,
  activeTabIndex,
  hasActiveApplication = false,
  propertyId,
}: {
  tabs: LineTabType[];
  activeTabIndex: ActiveTabIndex;
  hasActiveApplication?: boolean;
  propertyId: string;
}) => {
  const [activeIndex, setActiveIndex] = useState<number>(activeTabIndex);

  return (
    <div>
      <div className="flex h-[56px] flex-row justify-between border-b text-base">
        <div className="flex h-[56px] w-[272px] flex-row gap-8 opacity-100">
          {tabs.map((tab, index) => (
            <span
              className={clsx(
                index === activeIndex ? "border-b-[3px]" : "text-gray",
                "cursor-pointer border-primary duration-300",
                "hover:border-b-[3px] hover:text-black",
                "h-[56px] pt-3 pr-2 pb-5 pl-2 opacity-100",
                tab.width,
                tab.className
              )}
              onClick={() => setActiveIndex(index)}
              key={tab.label}
            >
              {tab.label}
            </span>
          ))}
        </div>
        <div className="self-start">
          <Button
            text="メッセージを一括送信"
            isDisabled={!hasActiveApplication}
            width="w-[192px]"
            height="h-12"
            style="outline"
            href={`/property/${propertyId}/announcement`}
          />
        </div>
      </div>
      <div className="pt-6">{tabs[activeIndex].children}</div>
    </div>
  );
};

export default LineTabs;
